import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IToken } from "@framework/types";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { Erc20CoinsListItem } from "./item";

export interface IErc20CoinsListProps {
  embedded?: boolean;
}

export const Erc20CoinsList = (props: IErc20CoinsListProps) => {
  const { embedded } = props;

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >("/erc20/coins", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc20.coins"]} isHidden={embedded} />

      <PageHeader message="pages.erc20.coins.title" />

      <SearchWithFilters endAdornmentIcon={null} />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(token => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={token.id}>
                <Erc20CoinsListItem token={token} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
